import { render, staticRenderFns } from "./LCChooser.vue?vue&type=template&id=6d80a791&"
import script from "./LCChooser.vue?vue&type=script&lang=ts&"
export * from "./LCChooser.vue?vue&type=script&lang=ts&"
import style0 from "./LCChooser.vue?vue&type=style&index=0&id=6d80a791&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports